module.exports = __webpack_public_path__ + "img/first-day-8.8c885be7.png";